import * as React from "react"

const Head = ({ children, quote }) => {
  return <></>
}

export default Head
